module.exports = __webpack_public_path__ + "static/Concert Finance-1298cbee8b2cd2456f5ee3cba3d15d21.jpg";